/**
 * Checks if any student ID in the given data exists in any group's student array
 * @param {Array} data - The data to check
 * @param {Array} groupData - The list of groups to check against
 * @returns {boolean} True if any student ID exists in any group's student array, false otherwise
 */
export function checkStudentIds(data, groupData) {

  // First, collect all student IDs from groupData
  const groupStudentIds = new Set();
  groupData.forEach((group) => {
    if (group.student && Array.isArray(group.student)) {
      group.student.forEach((studentId) => groupStudentIds.add(studentId));
    }
  });


  // Then check if any data config ID exists in the group student IDs
  for (const item of data) {
    if (!item.config || !Array.isArray(item.config)) continue;

    for (const configId of item.config) {
      // Check if this config ID exists in any group's student array
      if (groupStudentIds.has(configId)) {
        return true;
      }
    }
  }

  return false;
}


  // Compute available students for dropdown
  export const getAvailableStudents = (previewData, data, listStudents) => {
    // When editing, we need to include students that are part of the current group
    if (previewData) {
      // Get IDs of students in other groups (excluding the current group being edited)
      const otherGroupsStudentIds = new Set(
        data
          .filter(item => item.id !== previewData.id)
          .flatMap(item => item.config)
      );
      
      // Filter out students that are already in other groups
      return listStudents.filter(
        student => !otherGroupsStudentIds.has(student.id)
      );
    } else {
      // For new groups, filter out students that are in any group
      const configStudentIds = new Set(data.flatMap(item => item.config));
      return listStudents.filter(
        student => !configStudentIds.has(student.id)
      );
    }
  };